<template>
    <v-container class="main-container responsive-height">
        <v-row dense>
            <v-col cols="12" md="7">
                <MyTrading></MyTrading>
            </v-col>
            <v-col cols="12" md="5">
                <MyBalance></MyBalance>
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="12" sm="2" v-for="item in forecast" :key="item.day">
                <v-card
                    outlined
                    tile
                    :to="item.links"
                    :color="$vuetify.theme.dark ? '#162334' : '#E8F1F8'"
                    class="widgets-card"
                >
                    <v-btn
                        class="mx-2 mb-3"
                        fab
                        link
                        small
                        elevation="0"
                        :color="$vuetify.theme.dark ? '#1A2A3E ' : '#F8F6FC'"
                    >
                        <v-icon color="greenMain">
                            {{ item.icon }}
                        </v-icon>
                    </v-btn>
                    <p class="mb-0">{{ item.day }}</p>
                </v-card>
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="12" xl="7">
                <MyTradingAccount></MyTradingAccount>
            </v-col>
            <v-col cols="12" xl="5">
                <BarChart></BarChart>
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="12">
                <TransactionsTable></TransactionsTable>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import BarChart from "@/components/BarChart/BarChart.vue";
import MyBalance from "@/components/MyBalance/MyBalance.vue";
import MyTrading from "@/components/MyTrading/MyTrading.vue";
import MyTradingAccount from "@/components/MyTrading/MyTradingAccount.vue";
import TransactionsTable from "@/components/TransactionsTable/TransactionsTable.vue";
import { COMPANYINFO__ACTIONS } from "@/store/action-types";

import { mapState, mapMutations, mapActions, mapGetters } from "vuex";

export default {
    data: () => ({
        forecast: [
            { day: "Deposit", icon: "mdi-tray-arrow-down", links: "/deposit" },
            { day: "Withdraw", icon: "mdi-tray-arrow-up", links: "/withdraw" },
            {
                day: "Internal Transfer",
                icon: "mdi-swap-horizontal",
                links: "/internal-transfer",
            },
            { day: "MT5 Acc.", icon: "mdi-signal", links: "/mt5-accounts" },
            {
                day: "Verification",
                icon: "mdi-account-check-outline",
                links: "/profile-verify",
            },
            { day: "Support", icon: "mdi-chat-outline", links: "/support" },
        ],
    }),
    components: {
        MyTrading,
        MyBalance,
        MyTradingAccount,
        BarChart,
        TransactionsTable,
    },
    computed: {
        ...mapState("company", ["generalInfo"]),
    },
    methods: {
        ...mapActions("company", [COMPANYINFO__ACTIONS.COMPANYINFO]),
    },
    async mounted() {
        await this[COMPANYINFO__ACTIONS.COMPANYINFO]();
        document.title = `Dashboard | ${this.generalInfo?.company_name}`;
    },
};
</script>
